import { connect } from 'react-redux';

import AwardsPage from './AwardsPage';

const mapStateToProps = state => ({
    awards: state.data.awards,
    seasons: state.data.seasons,
    winners: state.data.winners,
    teamAwards: state.data.teamAwards
});

const Awards = connect(mapStateToProps)(AwardsPage);

export default Awards;



// WEBPACK FOOTER //
// ./src/views/awards/index.js